import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getGHRData,
  getGHRConditionsNumber,
  getGHRTopCondition,
} from "../../../../state/selectors/GHR.selectors";
import { CHRType } from "../../../componentTypes/GHRType";

const GeneGHRCard = ({
  card,
  ghrConditionsNumber,
  ghrData,
  ghrTopCondition,
}) => {
  const isDisabled = !Object.keys(ghrData || {}).length;

  return (
    <CardWrapper {...card} isDisabled={isDisabled}>
      {ghrTopCondition && (
        <div>
          {`Top Condition: `}
          <span className="tw-font-bold" data-testid="gene-ghr-top-condition">
            {ghrTopCondition}
          </span>
        </div>
      )}
      {ghrConditionsNumber && (
        <div>
          {`Conditions: `}
          <span
            className="tw-font-bold"
            data-testid="gene-ghr-conditions-number"
          >
            {ghrConditionsNumber}
          </span>
        </div>
      )}
    </CardWrapper>
  );
};

GeneGHRCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  ghrData: CHRType,
  ghrConditionsNumber: PropTypes.number,
  ghrTopCondition: PropTypes.string,
};

GeneGHRCard.defaultProps = {
  ghrData: {},
  ghrConditionsNumber: null,
  ghrTopCondition: null,
};

const mapStateToProps = (state) => ({
  ghrData: getGHRData(state),
  ghrConditionsNumber: getGHRConditionsNumber(state),
  ghrTopCondition: getGHRTopCondition(state),
});

export default connect(mapStateToProps, {})(GeneGHRCard);
